<div
  class="w-100 feedback-container d-flex justify-content-center align-items-center position-relative"
>
  <div
    class="hero-image-container d-flex justify-content-center align-items-center"
    [ngClass]="{
      'feedback-filled': feedback
    }"
  >
    <img
      src="../../../../../../../assets/img/feedback_hero.svg"
      alt="Imagem de um personagem e um balão de fala com a frase: 'O que achou dessa experiência?'"
      class="img-fluid hero-image"
      width="396"
      height="622"
    />
  </div>
  <div class="w-100 card m-0">
    <div class="card-content position-relative">
      <button
        type="button"
        title="Fechar"
        class="btn btn-sm position-absolute close-button p-1 d-flex flex-column justify-content-center align-items-center"
        (click)="closeButton()"
      >
        <i class="fa fa-times font-bold-400 black" aria-hidden="true"></i>
      </button>

      <div class="row">
        <div class="col">
          <div
            class="input-group w-100 px-4 d-flex justify-content-between align-items-center"
          >
            <div class="d-inline-block mr-3">
              <input
                id="fd-f-negatve"
                type="radio"
                name="feedback"
                value="negative"
                [checked]="feedback === 'negative'"
                [(ngModel)]="feedback"
                class="hidden-input"
              />
              <label
                for="fd-f-negatve"
                class="d-flex flex-column justify-content-start align-items-center normal-case cursor-pointer"
              >
                <svg
                  width="57"
                  height="58"
                  viewBox="0 0 57 58"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  [ngClass]="{
                    'feedback-icon__disabled':
                      feedback && feedback !== 'negative'
                  }"
                >
                  <path
                    d="M28.3459 3.61279C23.3626 3.61279 18.4911 5.09053 14.3476 7.85913C10.2041 10.6277 6.97467 14.5628 5.06762 19.1669C3.16058 23.7709 2.66161 28.837 3.63381 33.7246C4.60601 38.6122 7.00572 43.1017 10.5295 46.6255C14.0532 50.1493 18.5428 52.549 23.4304 53.5212C28.318 54.4934 33.3841 53.9944 37.9881 52.0874C42.5921 50.1803 46.5273 46.9509 49.2959 42.8074C52.0645 38.6638 53.5422 33.7924 53.5422 28.8091C53.5422 22.1266 50.8876 15.7178 46.1624 10.9926C41.4372 6.26739 35.0284 3.61279 28.3459 3.61279ZM28.3459 50.8558C23.9855 50.8558 19.723 49.5628 16.0974 47.1402C12.4719 44.7177 9.64607 41.2745 7.97741 37.246C6.30875 33.2175 5.87215 28.7846 6.72282 24.508C7.5735 20.2313 9.67325 16.303 12.7565 13.2197C15.8398 10.1364 19.7682 8.03663 24.0448 7.18595C28.3215 6.33527 32.7543 6.77187 36.7829 8.44053C40.8114 10.1092 44.2546 12.935 46.6771 16.5605C49.0996 20.1861 50.3927 24.4486 50.3927 28.8091C50.3927 34.6562 48.0699 40.2639 43.9353 44.3984C39.8008 48.533 34.1931 50.8558 28.3459 50.8558Z"
                    fill="#F03D3D"
                  />
                  <path
                    d="M39.6212 25.7854C41.1867 25.7854 42.4558 24.5163 42.4558 22.9508C42.4558 21.3853 41.1867 20.1162 39.6212 20.1162C38.0557 20.1162 36.7866 21.3853 36.7866 22.9508C36.7866 24.5163 38.0557 25.7854 39.6212 25.7854Z"
                    fill="#F03D3D"
                  />
                  <path
                    d="M17.9681 25.7854C19.5336 25.7854 20.8027 24.5163 20.8027 22.9508C20.8027 21.3853 19.5336 20.1162 17.9681 20.1162C16.4026 20.1162 15.1335 21.3853 15.1335 22.9508C15.1335 24.5163 16.4026 25.7854 17.9681 25.7854Z"
                    fill="#F03D3D"
                  />
                  <path
                    d="M28.5978 31.9585C26.3386 31.9589 24.1122 32.4993 22.1043 33.5348C20.0964 34.5703 18.3651 36.0707 17.0548 37.9111C16.8125 38.2515 16.7154 38.6742 16.7848 39.0862C16.8542 39.4981 17.0845 39.8657 17.4248 40.1079C17.7652 40.3502 18.1879 40.4473 18.5999 40.3779C19.0119 40.3084 19.3794 40.0782 19.6216 39.7378C20.6285 38.3236 21.9553 37.1671 23.4937 36.3627C25.0322 35.5582 26.7389 35.1285 28.4749 35.1085C30.2109 35.0886 31.927 35.4789 33.4836 36.2478C35.0402 37.0167 36.3931 38.1424 37.4322 39.5331C37.6828 39.8672 38.0559 40.0881 38.4694 40.1472C38.8828 40.2063 39.3028 40.0987 39.6369 39.8481C39.971 39.5975 40.1919 39.2244 40.251 38.811C40.3101 38.3975 40.2025 37.9775 39.9519 37.6434C38.6318 35.8782 36.9181 34.4452 34.9471 33.4583C32.9761 32.4714 30.8021 31.9579 28.5978 31.9585Z"
                    fill="#F03D3D"
                  />
                </svg>

                <span class="mt-2"> Ruim </span>
              </label>
            </div>
            <div class="d-inline-block mr-3">
              <input
                id="fd-f-neutral"
                type="radio"
                name="feedback"
                value="neutral"
                [checked]="feedback === 'neutral'"
                [(ngModel)]="feedback"
                class="hidden-input"
              />
              <label
                for="fd-f-neutral"
                class="d-flex flex-column justify-content-start align-items-center normal-case cursor-pointer"
              >
                <svg
                  width="57"
                  height="58"
                  viewBox="0 0 57 58"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  [ngClass]="{
                    'feedback-icon__disabled':
                      feedback && feedback !== 'neutral'
                  }"
                >
                  <path
                    d="M37.9715 35.2026H19.0743C18.6566 35.2026 18.2561 35.3686 17.9608 35.6639C17.6654 35.9592 17.4995 36.3597 17.4995 36.7774C17.4995 37.1951 17.6654 37.5956 17.9608 37.8909C18.2561 38.1863 18.6566 38.3522 19.0743 38.3522H37.9715C38.3891 38.3522 38.7897 38.1863 39.085 37.8909C39.3803 37.5956 39.5462 37.1951 39.5462 36.7774C39.5462 36.3597 39.3803 35.9592 39.085 35.6639C38.7897 35.3686 38.3891 35.2026 37.9715 35.2026Z"
                    fill="#ECA317"
                  />
                  <path
                    d="M28.4446 3.61279C23.4612 3.61279 18.5898 5.09053 14.4463 7.85913C10.3028 10.6277 7.0733 14.5628 5.16625 19.1669C3.25921 23.7709 2.76024 28.837 3.73244 33.7246C4.70464 38.6122 7.10436 43.1017 10.6281 46.6255C14.1519 50.1493 18.6414 52.549 23.529 53.5212C28.4166 54.4934 33.4827 53.9944 38.0868 52.0874C42.6908 50.1803 46.6259 46.9509 49.3945 42.8074C52.1631 38.6638 53.6408 33.7924 53.6408 28.8091C53.6408 22.1266 50.9862 15.7178 46.261 10.9926C41.5358 6.26739 35.127 3.61279 28.4446 3.61279ZM28.4446 50.8558C24.0841 50.8558 19.8216 49.5628 16.1961 47.1402C12.5705 44.7177 9.74471 41.2745 8.07604 37.246C6.40738 33.2175 5.97078 28.7846 6.82146 24.508C7.67213 20.2313 9.77188 16.303 12.8552 13.2197C15.9385 10.1364 19.8668 8.03663 24.1435 7.18595C28.4201 6.33527 32.853 6.77187 36.8815 8.44053C40.91 10.1092 44.3532 12.935 46.7758 16.5605C49.1983 20.1861 50.4913 24.4486 50.4913 28.8091C50.4913 34.6562 48.1685 40.2639 44.034 44.3984C39.8994 48.533 34.2917 50.8558 28.4446 50.8558Z"
                    fill="#ECA317"
                  />
                  <path
                    d="M39.7196 25.7854C41.2851 25.7854 42.5542 24.5163 42.5542 22.9508C42.5542 21.3853 41.2851 20.1162 39.7196 20.1162C38.1541 20.1162 36.885 21.3853 36.885 22.9508C36.885 24.5163 38.1541 25.7854 39.7196 25.7854Z"
                    fill="#ECA317"
                  />
                  <path
                    d="M17.673 25.7854C19.2385 25.7854 20.5075 24.5163 20.5075 22.9508C20.5075 21.3853 19.2385 20.1162 17.673 20.1162C16.1075 20.1162 14.8384 21.3853 14.8384 22.9508C14.8384 24.5163 16.1075 25.7854 17.673 25.7854Z"
                    fill="#ECA317"
                  />
                </svg>

                <span class="mt-2"> Média </span>
              </label>
            </div>
            <div class="d-inline-block">
              <input
                id="fd-f-positive"
                type="radio"
                name="feedback"
                value="positive"
                [checked]="feedback === 'positive'"
                [(ngModel)]="feedback"
                class="hidden-input"
              />
              <label
                for="fd-f-positive"
                class="d-flex flex-column justify-content-start align-items-center normal-case cursor-pointer"
              >
                <svg
                  width="58"
                  height="58"
                  viewBox="0 0 58 58"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  [ngClass]="{
                    'feedback-icon__disabled':
                      feedback && feedback !== 'positive'
                  }"
                >
                  <path
                    d="M17.3558 34.2368C19.3018 38.6628 24.1259 41.7924 29.1937 41.7924C34.24 41.7924 39.0548 38.6547 41.0176 34.2479"
                    stroke="#1EC02E"
                    stroke-width="3.14953"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <circle cx="21.6364" cy="21.6362" r="2.5195" fill="#1EC02E" />
                  <circle cx="36.7535" cy="21.6362" r="2.5195" fill="#1EC02E" />
                  <path
                    d="M29.195 54.39C43.1098 54.39 54.39 43.1098 54.39 29.195C54.39 15.2802 43.1098 4 29.195 4C15.2802 4 4 15.2802 4 29.195C4 43.1098 15.2802 54.39 29.195 54.39Z"
                    stroke="#1EC02E"
                    stroke-width="3.14953"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>

                <span class="mt-2"> Boa </span>
              </label>
            </div>
          </div>
          <div *ngIf="feedback" class="input-group w-100 px-4">
            <textarea
              id="notes"
              name="notes"
              rows="3"
              placeholder="Deixe seu comentário"
              [(ngModel)]="notes"
              class="form-control w-100"
            ></textarea>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="row mb-0">
        <div class="col">
          <button
            type="button"
            [disabled]="loading"
            title="Substituir exercício"
            class="w-100 btn btn-primary px-4 white"
            (click)="send()"
          >
            Enviar
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
